import React from 'react';
import {
  Row, Col, Button, Badge,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Table from 'components/Table';
import DateText from 'components/DateText';
import { DTable } from 'types/table';
import { CellProps } from 'react-table';
import { BsCheck } from 'react-icons/bs';

function StatusBadge( { value }: { value?: string } ) {
  if ( value === 'Finalizado' ) return <Badge><BsCheck size={20} /></Badge>;
  if ( value === 'Error' ) return <Badge bg="danger"><BsCheck size={20} /></Badge>;
  if ( value === 'Pendiente' ) return <Badge bg="light"><BsCheck size={20} /></Badge>;
  return null;
}

function Account( {
  data, fetchData, isLoading, updateCrm,
  lastSyncMessage,
}:{
  isLoading?:boolean;
  data:DTable;
  fetchData: ( params:any, pageSize:number )=>void ;
  updateCrm?: ( )=>void ;
  lastSyncMessage: string;
} ) {
  const { t } = useTranslation();

  return (
    <>
      <Row className="mt-2">
        <Col>
          <p>{lastSyncMessage}</p>
        </Col>
        <Col md={3} className="text--right">
          <Button
            size="sm"
            className="pt-2 pb-2 text--normal btn--rounded"
            onClick={updateCrm}
          >
            <div>
              {t( 'admin.common.updatecrm' )}
            </div>
          </Button>
        </Col>
      </Row>

      <Table
        columns={[
          {
            Header: t( 'admin.crm.createdAt' ),
            accessor: 'createdAt',
            Cell: ( { cell }: CellProps<any> ) => ( <DateText value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.status' ),
            accessor: 'status',
          },
          {
            Header: t( 'admin.crm.updatedAt' ),
            accessor: 'updatedAt',
            Cell: ( { cell }: CellProps<any> ) => ( <DateText value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.promocionesStatus' ),
            accessor: 'promocionesStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.promocionesImagenesStatus' ),
            accessor: 'promocionesImagenesStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.futurasInversionesImagenesStatus' ),
            accessor: 'futurasInversionesImagenesStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.productosStatus' ),
            accessor: 'productosStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.contactosStatus' ),
            accessor: 'contactosStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.cuentasInvercionStatus' ),
            accessor: 'cuentasInvercionStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.cuentasInv_ContactosStatus' ),
            accessor: 'cuentasInv_ContactosStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.cuentasInv_PromocionesStatus' ),
            accessor: 'cuentasInv_PromocionesStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.aportesRepartosStatus' ),
            accessor: 'aportesRepartosStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.proyectos_PromocionesStatus' ),
            accessor: 'proyectos_PromocionesStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.avanceFotograficoStatus' ),
            accessor: 'avanceFotograficoStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.avanceFotograficoKeysStatus' ),
            accessor: 'avanceFotograficoKeysStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.informesFinancierosStatus' ),
            accessor: 'informesFinancierosStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
          {
            Header: t( 'admin.crm.documentacionStatus' ),
            accessor: 'documentacionStatus',
            className: 'text-center',
            Cell: ( { cell }: CellProps<any> ) => ( <StatusBadge value={cell.value} /> ),
          },
        ]}
        isLoading={isLoading}
        data={data.data}
        total={data.totalItems}
        pageCount={data.pageCount}
        fetchData={fetchData}
      />
    </>
  );
}

export default Account;
